import React from 'react';

const Logo = ({ className }) => (
    <svg width="180" height="55" viewBox="28 50 180 55" xmlns="http://www.w3.org/2000/svg" className={className}>
        <g>
            <path d="M40.9 54.7 28.9 87.3 40.1 87.3 41.3 83.5 53 83.5 54.2 87.3 65.4 87.3 53.4 54.7 41 54.7ZM43.9 74.9 47.1 64.4 50.3 74.9 43.8 74.9Z" fill="#FFFFFF"/>
            <path d="M76.6 87.3 89.1 69.6 89.1 69.6 109.1 41.2 98.7 41.2 83.7 62.6 77.9 54.8 67.1 54.8 78.5 69.9 66.1 87.3 76.6 87.3Z" fill="#FFFFFF"/>
            <path d="M114.7 54.7 104.3 54.7 91.7 72.4 71.9 100.5 82.3 100.5 97.2 79.3 97.2 79.3 103 87.1 113.7 87.1 102.3 72.1 114.7 54.7Z" fill="#00BCD4"/>
            <path d="M130.4 54.2C120.3 54.2 112.6 61 112.6 71.1 112.6 81.2 120.4 88 130.4 88 140.4 88 148.2 81.2 148.2 71.1 148.2 61 140.4 54.2 130.4 54.2ZM130.4 79.2C125.7 79.2 122.6 75.6 122.6 71 122.6 66.4 125.7 62.8 130.4 62.8 135.1 62.8 138.2 66.4 138.2 71 138.2 75.6 135.1 79.2 130.4 79.2Z" fill="#FFFFFF"/>
            <path d="M151.7 87.3 161.6 87.3 161.6 75.1 176.1 75.1 176.1 66.5 161.6 66.5 161.6 63.3 176.5 63.3 176.5 54.7 151.7 54.7 151.7 87.3Z" fill="#FFFFFF"/>
            <path d="M178.9 54.7 178.9 63.3 187.7 63.3 187.7 87.3 197.5 87.3 197.5 63.3 206.2 63.3 206.2 54.7 178.9 54.7Z" fill="#FFFFFF"/>
        </g>
    </svg>
);

export default Logo;